import QRCode from "qrcode";
import $ from "jquery";

export const generateQrCode = (text) => {
    $(".js-room-completion")
        .find(".js-completion-popup-text")
        .append(`<div class="ch-qr-code"></div>`);
    QRCode.toCanvas(
        text,
        { width: 118, errorCorrectionLevel: "H" },
        function (err, element) {
            if (err) throw err;

            $(".ch-qr-code").append(element);
        },
    );
};
